/**
 * Polling Control — lets upload-heavy code temporarily pause background
 * polling so Chrome's 6-connection-per-host limit on the :8000 backend
 * doesn't cause ERR_TIMED_OUT on file uploads.
 *
 * Sedan A11 (2026-10-07) går all bakgrundspollning i skalet (notiser,
 * inkorgsräknare, systemhälsa, integrationslist, synklist, underhållsläge,
 * feedbackmärke) genom `usePolling` i ./usePolling.js, som läser
 * `isPollingPaused()` varje varv och dessutom pausar i dolda flikar.
 *
 * Usage:
 *   import { pausePolling, resumePolling } from '../../utils/pollingControl';
 *   pausePolling();        // before upload
 *   try { … } finally { resumePolling(); }
 *
 *   // Egen pollning utanför usePolling:
 *   import { isPollingPaused } from '../utils/pollingControl';
 *   if (isPollingPaused()) { setTimeout(tick, 2000); return; }
 */

let _paused = false;

/** Pause all background polling loops. */
export function pausePolling() {
  _paused = true;
}

/** Resume background polling loops. */
export function resumePolling() {
  _paused = false;
}

/** Returns true when polling should be skipped. */
export function isPollingPaused() {
  return _paused;
}
